import './Loading360.css';

import { globalStyles } from 'theme/styles';

interface Loading360Props {
	size?: number;
	className?: string;
	message?: string | boolean;
	variant?: 'gradient' | 'solid';
	fullScreen?: boolean;
	bgColor?: string;
	pulse?: boolean;
	centered?: boolean;
	table?: boolean;
}

export const Loading360 = ({
	size = 300,
	className = '',
	message = false,
	variant = 'gradient',
	fullScreen = false,
	bgColor = 'white',
	pulse = false,
	centered = false,
	table = false,
}: Loading360Props) => {
	const isCentered = centered || table;
	const colors = globalStyles.colors.loader360;
	const gradientId = `grad360-${Math.random().toString(36).substring(2, 11)}`;
	const strokeColor =
		variant === 'gradient' ? `url(#${gradientId})` : colors.solid;

	let displayMessage: string | null = null;
	if (message === true) {
		displayMessage = 'Carregando dados...';
	} else if (typeof message === 'string' && message !== '') {
		displayMessage = message;
	}

	const content = (
		<>
			<svg
				viewBox='0 0 35.04 37.2'
				xmlns='http://www.w3.org/2000/svg'
				className='loader'
				preserveAspectRatio='xMidYMid meet'
				style={{ width: `${size}px` }}
			>
				{variant === 'gradient' && (
					<defs>
						{/* Gradiente com ângulo -35° e escala 50% */}
						<linearGradient
							id={gradientId}
							gradientUnits='userSpaceOnUse'
							x1='0'
							y1='37.2'
							x2='35.29'
							y2='0'
						>
							<stop
								offset='0%'
								stopColor={colors.gradientStart}
							/>
							<stop
								offset='100%'
								stopColor={colors.gradientEnd}
							/>
						</linearGradient>
					</defs>
				)}
				<g>
					{/* Logo completa */}
					<path
						className={`loader_path ${
							pulse ? 'loader_path_pulse' : ''
						} st1`}
						d='M20.4,22.48c-1.93,1.99-3.67,2.06-5.47,0.19c-0.86,1.96-2.19,3.37-4.35,3.85c-1.43,0.32-2.78,0.13-4.06-0.54
            c-2.52-1.3-3.69-4.36-2.72-7.03c0.96-2.65,3.66-4.2,6.44-3.64c-0.72,0.8-1.27,1.66-2.37,2.05c-1.79,0.63-2.71,2.34-2.42,4.17
            c0.28,1.73,1.71,3.07,3.5,3.25c1.74,0.18,3.46-0.98,4.04-2.72c0.56-1.68-0.11-3.4-1.71-4.41c-0.2-0.13-0.41-0.24-0.71-0.42
            c1.27-1.41,2.51-2.8,3.88-4.32c-1.36,0-2.56,0-3.67,0c-0.73-0.64-1.36-1.19-2.11-1.86c3.34,0,6.53,0,9.91,0
            c-1.78,1.96-3.47,3.83-5.18,5.7c0.64,0.73,1.12,1.5,1.37,2.13c1.67-1.47,3.33-2.95,5.13-4.54c0.41,0,1.07,0,1.92,0
            c-1.16,1.22-2.21,2.32-3.27,3.45c0.61,0.51,1.33,0.83,1.83,1.68c0.66-1.7,1.61-3.02,3.2-3.76c1.57-0.73,3.17-0.77,4.77-0.18
            c2.42,0.89,3.94,3.43,3.66,6.08c-0.27,2.55-2.31,4.71-4.82,5.09
            C24.2,27.14,21.87,25.72,20.4,22.48z'
						style={{ stroke: strokeColor }}
					/>
					<path
						className={`loader_path ${
							pulse ? 'loader_path_pulse' : ''
						} st2`}
						d='M21.18,12.54c0.58-0.48,1.16-0.96,1.88-1.57c2.75,0,5.73,0,8.94,0c-0.64,0.68-1.17,1.24-1.69,1.8
            c-3.02,0-6,0-8.98,0C21.28,12.7,21.23,12.62,21.18,12.54z'
						style={{ stroke: strokeColor }}
					/>
					<path
						className={`loader_path ${
							pulse ? 'loader_path_pulse' : ''
						} st0`}
						d='M22.28,20.98c-0.01-2.21,1.72-3.96,3.92-3.94c2.17,0.02,3.89,1.71,3.91,3.85c0.03,2.16-1.76,3.94-3.95,3.94
            C24,24.82,22.29,23.13,22.28,20.98z'
						style={{ stroke: strokeColor }}
					/>
					<path
						className={`loader_path ${
							pulse ? 'loader_path_pulse' : ''
						} st3`}
						d='M18.99,20.9c-0.09,0.93-0.6,1.45-1.47,1.44c-0.81-0.01-1.37-0.55-1.39-1.35c-0.02-0.85,0.48-1.42,1.39-1.44
            C18.44,19.53,18.86,20.1,18.99,20.9z'
						style={{ stroke: strokeColor }}
					/>
				</g>
			</svg>
			{displayMessage && <p>{displayMessage}</p>}
		</>
	);

	if (fullScreen) {
		return (
			<div
				className={className}
				style={{
					width: '100vw',
					height: '100vh',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: bgColor,
				}}
			>
				{content}
			</div>
		);
	}

	if (isCentered) {
		return (
			<div
				className={className}
				style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: '1px',
				}}
			>
				{content}
			</div>
		);
	}

	return <div className={className}>{content}</div>;
};
